import 'twin.macro';
import 'styled-components/macro';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { PopperContentProps } from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './styles.module.css';

export interface TooltipProps {
  children?: ReactNode;
  className?: string;
  content?: ReactNode;
  disabled?: boolean;
  placement?: PopperContentProps['side'];
  /* sometimes additional span over the children breaks layout */
  spanClassName?: string;
  theme?: 'light' | 'dark';
}

export const Tooltip = ({
  children,
  className,
  content,
  disabled,
  placement,
  spanClassName,
  theme = 'light',
}: TooltipProps) => {
  if (disabled || !content) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={100}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          {/* See here for why we have the span: https://www.radix-ui.com/docs/primitives/components/tooltip#displaying-a-tooltip-from-a-disabled-button */}
          <span tabIndex={0} className={spanClassName}>
            {children}
          </span>
        </TooltipPrimitive.Trigger>

        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className={clsx([
              styles.tooltipContent,
              className,
              'p-1 rounded-lg shadow-card text-xs/snug  select-none z-overlay',
              theme === 'light' && 'bg-white text-primary',
              theme === 'dark' && 'bg-blue-darker text-white',
            ])}
            side={placement}
          >
            {content}
            {/* a 16x16 square after rotation gives 21x10.5 */}
            <TooltipPrimitive.Arrow
              className={clsx(theme === 'light' && `fill-white`, theme === 'dark' && 'fill-blue-darker')}
              width={21}
              height={10.5}
            />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
